import {ActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/ActDecorator';
import {Act} from '@gongxigames/framework/slotV2/fsm/acts/Act';

/**
 * Extend CycledActDecorator if you want to block the chain of other Acts.
 * It also has a condition to repeat its nested acts while condition is true
 * It is a promise like behaviour.
 */
export abstract class CycledActDecorator extends ActDecorator {
    public act?: Act;
    public abstract getName(): string;

    /**
     * repeat its nested acts while condition is true
     */
    public abstract cycleCondition(): boolean;

    /**
     * fill CycledActDecorator by actions here
     */
    public abstract setAct(): void;
}